import { Checkbox, Divider, Form, Input } from "antd";
import React, { FC, useEffect } from "react";
import {
  rulePhone,
  ruleRequired,
} from "../../../../../constants/rules/RulesConstantsForms";
import classes from "./style/AdditionalInformation.module.css";
import { useAppSelector } from "../../../../../store/reduxHooks";
import { useForm } from "antd/es/form/Form";
import { SELECT_APPLICATIONS_DATA_TO_BANK } from "../../../../../store/selectors/applicationDataToBankSelector";

export const AdditionalInformation: FC = () => {
  const information = useAppSelector(SELECT_APPLICATIONS_DATA_TO_BANK);
  const [form] = useForm();

  useEffect(() => {
    if (information) {
      form.setFieldsValue({
        address_legal: information.contact_application?.address_legal,
        address_factual: information.contact_application?.address_factual,
        actual_address_organization:
          information.contact_application?.actual_address_organization,
        post_address_organization:
          information.contact_application?.post_address_organization,
        phone: information.contact_application?.phone,
        email: information.contact_application?.email,
        bik: information.bank_requisites?.bik,
        name_bank: information.bank_requisites?.name_bank,
        account_number: information.bank_requisites?.account_number,
        account_correspondent:
          information.bank_requisites?.account_correspondent,
      });
    }
  }, [form, information]);

  return (
    <>
      <Divider orientation="left" orientationMargin="0">
        Дополнительная информация
      </Divider>
      <Form
        form={form}
        layout="vertical"
        name="additional_information_form"
        disabled
      >
        <Form.Item
          name="address_legal"
          label="Юридический адрес организации"
          rules={[ruleRequired]}
        >
          <Input placeholder="Введите юридический адрес" />
        </Form.Item>
        <Form.Item valuePropName="checked" name="actual_address_organization">
          <Checkbox>Юридический адрес совпадает с фактическим</Checkbox>
        </Form.Item>
        {!information?.contact_application?.actual_address_organization && (
          <Form.Item
            name="address_factual"
            label="Фактический адрес организации"
            rules={[ruleRequired]}
          >
            <Input placeholder="Введите фактический адрес" />
          </Form.Item>
        )}
        <Form.Item name="post_address_organization" label="Почтовый адрес">
          <Input placeholder="Введите почтовый адрес" />
        </Form.Item>
        <div className={classes.formInputWrapper}>
          <Form.Item
            label="Контактный телефон клиента"
            rules={[rulePhone, ruleRequired]}
            name="phone"
          >
            <Input placeholder="Введите телефон клиента" />
          </Form.Item>
          <Form.Item
            label="Контактный Email"
            name="email"
            rules={[
              {
                type: "email",
                message: "Введите корректный email",
              },
              ruleRequired,
            ]}
          >
            <Input placeholder="Введите контактный email" />
          </Form.Item>
        </div>
        <Divider orientation="left" orientationMargin="0">
          Реквизиты
        </Divider>
        <div className={classes.formInputWrapper}>
          <Form.Item label="БИК" name="bik">
            <Input placeholder="Введите БИК" />
          </Form.Item>
          <Form.Item label="Наименование банка" name="name_bank">
            <Input placeholder="Введите наименование банка" />
          </Form.Item>
        </div>
        <div className={classes.formInputWrapper}>
          <Form.Item label="Номер счета" name="account_number">
            <Input placeholder="Введите номер счета" />
          </Form.Item>
          <Form.Item
            label="Корреспондентский счет"
            name="account_correspondent"
          >
            <Input placeholder="Введите корреспондентский счет" />
          </Form.Item>
        </div>
      </Form>
    </>
  );
};
